import { usePwaInstall } from '../hooks/usePwaInstall';
import { t } from '../hooks/useT';

export function PwaInstallPrompt() {
  const { visible, canInstall, iosHint, install, dismiss } = usePwaInstall();

  if (!visible) return null;

  return (
    <div className="pwa-install-banner" role="dialog" aria-labelledby="pwa-install-title">
      <div className="pwa-install-banner-inner">
        <div className="pwa-install-banner-text">
          <strong id="pwa-install-title">{t('pwa.installTitle')}</strong>
          {iosHint && !canInstall && (
            <p className="muted">{t('pwa.iosHint')}</p>
          )}
        </div>
        <div className="pwa-install-banner-actions">
          {canInstall && (
            <button type="button" className="btn primary admin-btn-sm" onClick={() => void install()}>
              {t('pwa.installCta')}
            </button>
          )}
          <button type="button" className="btn secondary admin-btn-sm" onClick={dismiss}>
            {t('pwa.installDismiss')}
          </button>
        </div>
      </div>
    </div>
  );
}
